export type ViewLevel = 'MARKET' | 'PROPERTY' | 'PROPERTYSEARCH';

export class VIEW_LEVELS {
  static MARKET: ViewLevel = 'MARKET'
  static PROPERTY: ViewLevel = 'PROPERTY'
  static PROPERTYSEARCH: ViewLevel = 'PROPERTYSEARCH'
};



// WEBPACK FOOTER //
// ./src/app/main/constants/view-levels.ts